const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const DYNAMIC = {
  path: '/dynamic',
  name: 'dynamic',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'dynamic-list' },
  meta: {
    title: '动态记录',
    requiresAuth: true,
    hideChildrenInMenu: true,
    roles: 'dynamicRecord',
    order: 16
  },
  children: [
    {
      path: 'index',
      name: 'dynamic-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'dynamic-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'dynamicRecord:view',
        title: '动态记录'
      },
      children: [
        {
          path: '',
          name: 'dynamic-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 16 },
          meta: {
            requiresAuth: true,
            roles: 'dynamicRecord:view',
            title: '动态记录'
          }
        },
        {
          path: ':id',
          name: 'dynamic-index-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 16 },
          meta: {
            requiresAuth: true,
            title: '动态记录详情',
            roles: 'dynamicRecord:view'
          }
        }
      ]
    }
  ]
};

export default DYNAMIC;
